import React from "react";
import ReactDOM from "react-dom";
import {createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
import App from "./App";
import "./index.css";
import "typeface-roboto";

const theme = createMuiTheme({
	typography: {
		useNextVariants: true
	},
	palette: {
		primary: {main: "#156bb4"},
		secondary: {main: "#156bb4"}
	}
});

function ThemeApp() {

	return (
		<MuiThemeProvider theme={theme}>
			<App/>
		</MuiThemeProvider>
	);
}


ReactDOM.render(<ThemeApp/>, document.getElementById("root"));
